import type React from 'react';

export function TrackingSkeleton(): React.JSX.Element {
  return (
    <div className="flex gap-2">
      <div className="h-9 w-36 animate-pulse rounded-full bg-muted" />
      <div className="h-9 w-32 animate-pulse rounded-full bg-muted" />
    </div>
  );
}
